"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CameraFilled_1 = __importDefault(require("../icons/generated/CameraFilled"));
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
var image_utils_1 = require("./utils/image-utils");
var modal_component_1 = __importDefault(require("../modal/modal.component"));
exports.AddPhotoRectangle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 146px;\n  height: 104px;\n  color: ", ";\n  background: ", ";\n  cursor: pointer;\n\n  span {\n    opacity: 0.9;\n  }\n\n  &:hover span {\n    opacity: 1;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 146px;\n  height: 104px;\n  color: ", ";\n  background: ", ";\n  cursor: pointer;\n\n  span {\n    opacity: 0.9;\n  }\n\n  &:hover span {\n    opacity: 1;\n  }\n"])), function () { return dark_theme_1.default.colours.image.uploader.color; }, function () { return dark_theme_1.default.colours.image.uploader.backgroundColor; });
exports.IconWrapper = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 32px;\n  height: 32px;\n\n  svg {\n    fill: currentColor;\n  }\n"], ["\n  width: 32px;\n  height: 32px;\n\n  svg {\n    fill: currentColor;\n  }\n"])));
exports.AddPhotoText = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: bold;\n  color: currentColor;\n"], ["\n  font-size: 14px;\n  line-height: 20px;\n  font-weight: bold;\n  color: currentColor;\n"])));
var ImageUploader = function (_a) {
    var imagePlaceholder = _a.imagePlaceholder, onImageSelected = _a.onImageSelected, testID = _a.testID, maxImgSizeMB = _a.maxImgSizeMB, maxSizeReachedMessage = _a.maxSizeReachedMessage, wrongFormatUploadedMessage = _a.wrongFormatUploadedMessage;
    var inputRef = react_1.useRef(null);
    var _b = react_1.useState(false), maximumSizeReached = _b[0], setMaximumSizeReached = _b[1];
    var _c = react_1.useState(false), wrongFormatUploaded = _c[0], setWrongFormatUploaded = _c[1];
    var uploadImage = function () {
        var _a;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var onFileChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var fileUploaded, fileSize, _a;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    fileUploaded = (_c = (_b = event === null || event === void 0 ? void 0 : event.target) === null || _b === void 0 ? void 0 : _b.files) === null || _c === void 0 ? void 0 : _c[0];
                    fileSize = fileUploaded === null || fileUploaded === void 0 ? void 0 : fileUploaded.size;
                    if (!fileSize) {
                        return [2 /*return*/];
                    }
                    if (!(fileUploaded === null || fileUploaded === void 0 ? void 0 : fileUploaded.type.includes('image'))) {
                        setWrongFormatUploaded(true);
                        return [2 /*return*/];
                    }
                    if (maxImgSizeMB && fileSize && image_utils_1.convertSizeToMB(fileSize, 2) > maxImgSizeMB) {
                        setMaximumSizeReached(true);
                        return [2 /*return*/];
                    }
                    _a = onImageSelected;
                    return [4 /*yield*/, image_utils_1.getBase64(fileUploaded)];
                case 1:
                    _a.apply(void 0, [_d.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { type: "file", ref: inputRef, id: "imageUploader", onChange: onFileChange, style: { display: 'none' } }),
        react_1.default.createElement(exports.AddPhotoRectangle, { onClick: uploadImage, "data-test-id": testID, className: "image-uploader-button" },
            react_1.default.createElement(exports.IconWrapper, null,
                react_1.default.createElement(CameraFilled_1.default, null)),
            react_1.default.createElement(exports.AddPhotoText, null, imagePlaceholder)),
        maximumSizeReached && maxSizeReachedMessage && (react_1.default.createElement(modal_component_1.default, { show: maximumSizeReached, title: maxSizeReachedMessage, close: function () { return setMaximumSizeReached(false); }, testID: "maximum-size-modal" })),
        wrongFormatUploaded && wrongFormatUploadedMessage && (react_1.default.createElement(modal_component_1.default, { show: wrongFormatUploaded, title: wrongFormatUploadedMessage, close: function () { return setWrongFormatUploaded(false); }, testID: "wrong-format-modal" }))));
};
ImageUploader.displayName = 'ImageUploader';
exports.default = ImageUploader;
var templateObject_1, templateObject_2, templateObject_3;
